import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  methods: null,

  orderId: null,
  orderSum: null,

  signature: '',

  orderCost: null, /* стоимость к оплате с комиссией */
  orderCurrency: '',

  qrUrl: null,

  status: null,
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentMethods: (state, action) => { state.methods = action.payload },

    setOrderId: (state, action) => { state.orderId = action.payload },
    setOrderSum: (state, action) => { state.orderSum = action.payload },

    setProcessingSignature: (state, action) => { state.signature = action.payload },

    setOrderCostSum: (state, action) => { state.orderCost = action.payload },
    setOrderCostCurrency: (state, action) => { state.orderCurrency = action.payload },

    setWalletQrUrl: (state, action) => { state.qrUrl = action.payload },

    setPaymentStatus: (state, action) => { state.status = action.payload },

    resetPayment: () => initialState,
  },
})

export const {
  setPaymentMethods,

  setOrderId,
  setOrderSum,

  setProcessingSignature,

  setOrderCostSum,
  setOrderCostCurrency,

  setWalletQrUrl,

  setPaymentStatus,

  resetPayment,
} = paymentSlice.actions

export default paymentSlice.reducer
